(function () {
    'use strict';

    angular.module('NaviaqWebApp').controller('importPriceAdjustmentsFromCsvModalController', importPriceAdjustmentsFromCsvModalController);

    importPriceAdjustmentsFromCsvModalController.$inject = [
        '$scope',
        '$rootScope',
        '$windowInstance',
        'customerService',
        '$translate',
        'dateUtility'];

    function importPriceAdjustmentsFromCsvModalController(
        $scope,
        $rootScope,
        $windowInstance,
        customerService,
        $translate,
        dateUtility) {

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.importFileSelector = "priceAdjustImport";
        $scope.displayImportResult = false;
        $scope.importResult = null;
        $scope.importData = {
            fromDate: null,
            toDate: null
        };

        $scope.validateForm = validateForm;

        $scope.fileImportOptions = {
            multiple: false,
            localization: {
                select: $translate.instant('G_SELECT'),
            },
        };

        $scope.validatorOptions = {
            rules: {
                validateFromDate: function(input) {
                    if (input.is("[id='from-date-picker']") && input.val()) {
                        return !!kendo.parseDate(input.val(), "dd.MM.yyyy");
                    }
                    return true;
                },
                validateToDate: function(input) {
                    if (input.is("[id='to-date-picker']") && input.val()) {
                        const toDate = kendo.parseDate(input.val(), "dd.MM.yyyy");
                        if (!toDate) return false;

                        const fromDateString = $('#from-date-picker').val();
                        if (fromDateString) {
                            const fromDate = kendo.parseDate(fromDateString, "dd.MM.yyyy");
                            if (fromDate) {
                                return toDate >= fromDate;
                            }
                        }
                    }
                    return true;
                }
            },
            messages: {
                validateFromDate: $translate.instant('UNIT_FROM_DATE_MIN'),
                validateToDate: $translate.instant('UNIT_TO_DATE_AFTER_FROM')
            },
            validateOnBlur: true
        };

        $scope.selectedFiles = [];

        $scope.$on(`${$scope.importFileSelector}ReturnSelectedFiles`, function (event, documents) {
            $scope.selectedFiles = documents;

            if (!documents || documents.length == 0) {
                logImportResult($translate.instant('ADMIN_CUSTOMERS_PRICE_ADJUST_NO_FILE_SELECTED'));

                $rootScope.$broadcast('hideBusyIndicator', 'importPricesModalStart');
            }
            else if (documents.length == 1) {
                startImport(documents[0]);
            }
            else {
                logImportResult($translate.instant('ADMIN_CUSTOMERS_PRICE_ADJUST_MORE_THAN_ONE_FILE_SELECTED'));
                $rootScope.$broadcast('hideBusyIndicator', 'importPricesModalStart');
            }
        });

        initController();
        function initController() {
            // Initialize dates to today and a month from today
            const today = new Date();

            const nextMonth = new Date(today);
            nextMonth.setMonth(nextMonth.getMonth() + 1);

            $scope.importData.fromDate = today;
            $scope.importData.toDate = nextMonth;
        }

        function validateForm() {
            if (!$scope.validator) {
                return false;
            }
            return $scope.validator.validate();
        }

        function ok() {
            if (!validateForm()) {
                return;
            }

            $scope.displayImportResult = true;
            $scope.importResult = null;
            logImportResult($translate.instant('ADMIN_CUSTOMERS_PRICE_ADJUST_IMPORT_STARTED'));

            $rootScope.$broadcast('showBusyIndicator', { id: 'importPricesModalStart', destination: '#import-price-adjustments-form' });

            //use broadcast to get the selected file from the file-importer-directive
            $rootScope.$broadcast(`${$scope.importFileSelector}GetSelectedFiles`);
            //result will be caught in the on (ReturnSelectedFiles) event above, which will call the startImport function
        }

        function cancel() {
            $windowInstance.close({ result: false });
        }

        function startImport(importFile) {
            const fromDateIso = dateUtility.toIsoString($scope.importData.fromDate);
            const toDateIso = dateUtility.toIsoString($scope.importData.toDate);

            customerService.importCustomerPriceChangesCsv(importFile, fromDateIso, toDateIso)
                .then((importResult) => {
                    //display import result
                    $scope.displayImportResult = true;
                    logImportResult(importResult);
                    logImportResult($translate.instant('ADMIN_CUSTOMERS_PRICE_ADJUST_IMPORT_COMPLETED'));
                })
                .catch(error => {
                    logImportResult($translate.instant('ADMIN_CUSTOMERS_PRICE_ADJUST_IMPORT_FAILED'));
                    const data = typeof error.data == 'object' ? JSON.stringify(error.data) : error.data;
                    logImportResult(`Problem ${error.status} : ${data}`);
                })
                .finally(() => {
                    $rootScope.$broadcast('hideBusyIndicator', 'importPricesModalStart');
                });
        }

        function logImportResult(logText) {
            if ($scope.importResult) {
                $scope.importResult += '\r\n' + logText;
            }
            else {
                $scope.importResult = logText;
            }
        }
    }
})();
